import { render, staticRenderFns } from "./IconFooter.vue?vue&type=template&id=f90e63ac&"
import script from "./IconFooter.vue?vue&type=script&lang=js&"
export * from "./IconFooter.vue?vue&type=script&lang=js&"
import style0 from "./IconFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports